var Actions;
(function (Actions) {
    Actions["GET_EXPORT_PROFIT_CENTER"] = "getExportProfitCenter";
    Actions["GET_EXPORT_BUDGET_TYPE"] = "getExportBudgetType";
    Actions["CREATE_EXPORT_BUDGET_TYPE"] = "createExportBudgetType";
    Actions["GET_EXPORT_VERSION"] = "getExportVersion";
    Actions["GET_CHECKED_PROFIT_CENTER"] = "getCheckedProfitCenter";
    Actions["GET_EXPORT_STATUS_FILE"] = "getExportStatusFile";
    Actions["GET_EXPORT_FILE"] = "getExportFile";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_EXPORT_LOADING"] = "setExportLoading";
    Mutations["SET_EXPORT_PROFIT_CENTER"] = "setExportProfitCenter";
    Mutations["SET_EXPORT_BUDGET_TYPE"] = "setExportBudgetType";
    Mutations["SET_EXPORT_STATUS"] = "setExportStatus";
    Mutations["SET_EXPORT_VERSION"] = "setExportVersion";
    Mutations["SET_CHECKED_PROFIT_CENTER"] = "setCheckedProfitCenter";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
